export default __webpack_public_path__ + "static/media/CastingImg.0cf85f9a.png";